<template>
  <div class="accounts transitionBody">
    <div class="accounts-head">
      <div class="account-left">
        <van-icon name="arrow-left" @click="back()"/>
      </div>
      <div class="accounts-head-text"> {{ $t('我的钱包') }}</div>
      <div class="accounts-details" @click="go('/transRecord')"> {{ $t('账户明细') }}</div>
    </div>
    <div class="vue-slim-better-scroll">
      <div class="vue-slim-better-scroll__wrapper" style="transition-duration: 0ms;">
        <div style="pointer-events: auto;">
          <div class="accounts-scroll">
            <div class="topArea">
              <div class="topArea_card">
                <div class="card_top">
                  <div class="card_top_left">
                    <img src="/static/image/new/mine/qianbao.png"><span>{{ $t('账户总资产') }}</span>
                  </div>
                  <div class="nums_box">
                    <div class="left-nums">{{
                        $store.state.userInfo.balance * 1 + $store.state.userInfo.gameblance * 1
                      }}
                    </div>
                    <div class="refresh"><img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAaCAYAAACgoey0AAAAAXNSR0IArs4c6QAAAvpJREFUSEutlluITWEUx39/zIQoIsUkJolIIUPkLiJFHsRIKdMkxQtKE1IiUoqUB2USTWYGhUQSSrnlFuUauURKrrk8uC17nfnOtGc7t3Fm1anT3mut3/7W9RMFipkNBBYCkwH/3xP4BXwEHgFngHpJrwtxqXxKZjYA2A7MA/Lp/wQOAeskvcrlO6cjM1sC7InAnfN9YOL9Z2ClpIPZ7PKB3wE9YsbXgAbgCvAGMKAMGBfSMCoBqpG0LRM8H/gYMBd4BlRLOpfr5GY2HdgL9I/pLZPkz1pIPnAJMCaC35b0rZBwm1l34AQwPuh73kdIuhe3bwE2s/b+UtLvQiDZdMysE3AZGB50LkqalAu80fMmaVMxYLc1s3LgPtAx+Jom6Xzab/OJg+KDUDBDJHleixIz88JaG5w0SlqQCexfMyW8uCBpalHUplP3BZ4D7YCv3iGSfqTSGcKyFNiXAFVJqm0D+C0vruCnQtKNFNjMeoWR1y0B+RRNoUGS3hYDN7P9UTv6IHKplFSfBnuvzgI6hJD4c69q/52S5KOy1WJmvaPR6a1UA6wKDtYAB5zlJ+4aFFZHDzYHhS3hf4mkL62mNuW3DlgUijU5L47Eq7o6TB3n1Eqq+h9g2sbMPHW+tTyVcXmfSmFM0as4PRJ9Uo0sBhyKdj7QmPCzWFJdHOwh96VQGsJTLulFG8BPArODn7OSZqSKK+7YzE4DM8OzHZK8GIoSM+sTQu7jeLCkl5nAvom8yl280YdKelIUuanQvHBLJW1N+/pnO5nZzWi7pPN7N7rSjJX0vVh40j4TuCIK99VYT18C5kj6UAg8tGeZpIe59DPuYzNbEc3V3TFDL7LlkrwGsoqZeRXvjNrS87peks+DjJL1ImBmG6JTJ9fjHeAo4FHwy5zb+4SaADh0WIxyXdLoVoPdwMx8eewCuhQS5piObyLv1+P/BQ7wfoBXo5/I53ku+RN1wmHfwflmQL57cjMkXBQqgYnej2EU+i3TR+Dj6Lnv8wZJTwuJzl/alPrprg+vsQAAAABJRU5ErkJggg==">
                    </div>
                  </div>
                </div>
                <div class="card_bottom">
                  <div class="account_money"> {{
                      $t('主账号余额')
                    }}<span> {{ $store.state.userInfo.balance * 1 + $store.state.userInfo.gameblance * 1 }} </span>
                  </div>
                  <div class="take_back" @click="transall">
                    <img src="/static/image/new/mine/monijiaoyi.png">
                    {{ $t('一键取回') }}
                  </div>
                </div>
              </div>
              <div class="venuesDetail">
                <div class="venues">
                  <van-switch v-model="checked2" size="18px" active-color="#3084ff" inactive-color="#d9dbe7"/>
                  <div class="left-nums">{{ $t('场馆余额明细') }}</div>
                </div>
                <div class="venuesList" v-show="checked2"><!---->
                  <div class="listbox">
                    <div class="item" v-for="(item, index) in balancelist" :key="index">
                      <div class="out">
                        <span class="tittleText">{{ item.name }}</span>
                        <img
                          v-if="index==0||index==3||index==9||index==11"
                          src="/static/image/new/mine/banben.png"
                          class="Popovershow">
                      </div>
                      <span class="moneyText">{{ item.balance }}</span>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div class="main-menu" v-show="!checked2">
              <div class="item" @click="go('/recharge')">
                <div class="bgbox out-transfer">
                  <img src="/static/image/new/mine/account-icon1.png">
                </div>
                <span>{{ $t('账户充值') }}</span>
              </div>
              <div class="item" @click="go('/withdrawal')">
                <div class="bgbox cash-out">
                  <img src="/static/image/new/mine/account-icon2.png">
                </div>
                <span>{{ $t('账户提现') }}</span>
              </div>
              <div class="item" @click="go('/transfer')">
                <div class="bgbox venues-transfer">
                  <img src="/static/image/new/mine/account-icon3.png">
                </div>
                <span>{{ $t('场馆转账') }}</span>
              </div>
<!--              <div class="item">-->
<!--                <div class="bgbox out-transfer">-->
<!--                  <img src="/static/image/new/mine/account-icon4.png">-->
<!--                </div>-->
<!--                <span>{{ $t('下线转账') }}</span>-->
<!--              </div>-->
            </div>
          </div>
        </div> <!---->
      </div>

    </div>
  </div>
</template>
<script>
import {translateText} from "../common/utils";

export default {
  name: 'money',
  data() {
    return {daoTime: null, balancelist: [], checked2: true};
  },
  created() {
    let that = this;
    that.getbalancelist();
    that.daoTime = setInterval(() => {
      that.getbalancelistNoLoding();
    }, 3500);
  },
  methods: {
    back() {
      window.history.go(-1)
    },
    go(s) {
      this.$router.push(s)
    },
    async showTost(type = 0, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    transall() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/transall', {})
        .then(res => {
          that.showTost(1, res.message);
          that.getbalancelist();
          that.refreshusermoney();
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getbalancelist() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun
        .post('/api/balancelist', {})
        .then(async (res) => {
          if (res.code !== 200) {
            that.showTost(0, res.message);
          }
          if (res.code === 200) {
            // that.balancelist = res.data;
            let balancelist = res.data;
            const arr = await translateText([balancelist[0].name]);
            balancelist[0].name = arr[0]
            that.balancelist = [balancelist[0]];
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getbalancelistNoLoding() {
      let that = this;

      that.$apiFun
        .post('/api/balancelist', {})
        .then(async (res) => {
          if (res.code !== 200) {
            that.showTost(0, res.message);
          }
          if (res.code === 200) {
            // that.balancelist = res.data;
            let balancelist = res.data;
            const arr = await translateText([balancelist[0].name]);
            balancelist[0].name = arr[0]
            that.balancelist = [balancelist[0]];
          }
        })
        .catch(res => {
        });
    },
    refreshusermoney() {
      let that = this;
      that.$apiFun.post('/api/refreshusermoney', {}).then(res => {
        that.$parent.hideLoading();
        if (res.code == 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
  },
  beforeDestroy() {
    let that = this;
    if (that.daoTime) {
      clearInterval(that.daoTime);
    }
    that.daoTime = null;
  },
};
</script>

<style scoped lang="scss">
.accounts {
  width: 100%;
  height: 100vh;
  background-color: #000;
  color: #fff;
  font-family: PingFang SC;
  background-image: url("/static/image/new/page-bg-img.png");
  background-size: cover;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .van-switch--on {
    background: linear-gradient(to bottom, #4B5BF1 40%, #B5BBF8) !important;
    border-color: #4B5BF1 !important;
  }
}

.accounts .accounts-scroll {
  overflow: scroll
}

.accounts .accounts-scroll, .accounts .accounts-scroll .topArea {
  display: flex;
  flex-direction: column
}

.accounts .accounts-scroll .topArea {
  border-radius: .13333rem;
  box-sizing: border-box;
  padding-top: .42667rem;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #fff
}

.accounts .topArea_card {
  flex-direction: column;
  justify-content: space-between;
  width: 9.2rem;
  height: 2.53rem;
  padding: .32rem .35rem;
  background: rgba(255, 255, 255, 0.10);
  border: 0.03rem solid rgba(255, 255, 255, 0.10);
  border-radius: .27rem;

}

.accounts .card_top, .accounts .topArea_card {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box
}

.accounts .card_top {
  align-items: flex-start;
}

.accounts .card_top .card_top_left {
  align-items: center;
}

.accounts .card_top .card_top_left {
  display: flex;
  font-size: .37333rem
}

.accounts .card_top .card_top_left img {
  height: .48rem;
  box-sizing: border-box
}

.accounts .card_top .card_top_left span {
  margin-left: .16rem;
  font-size: 0.32rem;
}

.accounts .card_bottom {
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
}

.accounts .card_bottom, .accounts .card_bottom .account_money {
  display: flex;
}

.accounts .card_bottom .account_money {
  align-items: center;
  color: #BBBBBB;
  flex-shrink: 0;
}

.accounts .card_bottom .account_money span {
  font-size: .37rem;
  color: #FFFFFF;
  margin-left: .16rem;
}

.accounts .card_bottom .take_back {
  height: .8rem;
  background: linear-gradient(to bottom, #4B5BF1 40%, #B5BBF8);
  border-radius: .11rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: .37rem;
  padding: 0 .29rem;
}

.accounts .card_bottom .take_back img {
  width: .43rem;
  margin-right: .21rem
}

.accounts .accounts-head {
  height: 1.17rem;
  line-height: 1.17rem;
  padding: 0 .4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.accounts .accounts-head .account-left {
  font-size: .48rem;
  width: 1.8rem;
}

.accounts .accounts-head .accounts-head-text {
  font-size: .48rem;
  flex: 1;
  text-align: center;
}

.accounts .accounts-head .accounts-details {
  font-size: .32rem;
  color: #BBBBBB;
  width: 1.8rem;
  text-align: right;
}

.accounts .new-accounts-nums {
  font-size: .37333rem;
  text-align: left;
  color: #1d2548;
  line-height: .37333rem;
  height: .37333rem;
  margin-left: .42667rem;
  box-sizing: border-box;
  font-weight: 500
}

.accounts .new-accounts-nums img {
  width: .37333rem;
  height: .37333rem
}

.accounts .nums_box {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.accounts .nums_box .left-nums {
  font-size: 0.69rem;
  line-height: .7rem;
  color: #fff;
  font-family: Gilroy;
}

.accounts .nums_box .refresh {
  margin-left: .24rem;
  height: 100%;
  display: flex;
  align-items: center
}

.accounts .nums_box .refresh img {
  width: .4rem;
}

.accounts .nums_box .saveMoneyBtn {
  width: 2rem;
  height: .8rem;
  box-shadow: 0 .08rem .10667rem 0 rgba(51, 70, 130, .2);
  padding: 0;
  background-color: #5691fe;
  border-radius: .50667rem
}

.accounts .nums_box .saveMoneyBtn .van-button__text {
  width: 2rem;
  height: .8rem;
  text-align: center;
  color: #fff;
  line-height: .8rem;
  font-family: PingFang-SC-Medium;
  font-size: .32rem;
  font-weight: 400
}

.accounts .main-menu {
  width: 100vw;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  //justify-content: space-between;
  padding: .3rem .4rem;
}

.accounts .main-menu .item {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 1.3rem;
}
.accounts .main-menu .item:nth-child(4n+4) {
  margin-right: 0;
}

.accounts .main-menu .item {
  width: 1.33333rem;
  flex-direction: column;
}

.accounts .main-menu .item .bgbox {
  width: 1.31rem;
  height: 1.31rem;
}

.accounts .main-menu .item .bgbox img {
  width: 100%;
  height: 100%
}

.accounts .main-menu .item span {
  width: 1.33333rem;
  font-size: .32rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
  margin-top: .16rem
}

.accounts .new-accounts-list {
  background: #fff;
  padding: 0 .26667rem .26667rem .26667rem;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1
}

.accounts .new-accounts-list .van-swipe-cell {
  height: 1.86667rem;
  margin-bottom: .26667rem
}

.accounts .new-accounts-list .van-swipe-cell .accounts-swipe-cell {
  height: 1.86667rem;
  background-color: #fff;
  box-shadow: 0 .10667rem .10667rem 0 rgba(87, 92, 115, .1);
  box-shadow: 0 .05333rem .10667rem 0 rgba(87, 92, 115, .1);
  border-radius: .13333rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex
}

.accounts .new-accounts-list .van-swipe-cell .accounts-swipe-cell img {
  width: 1.22667rem;
  height: 1.2rem;
  margin-top: .34667rem;
  margin-right: .34667rem;
  margin-left: .4rem
}

.accounts .new-accounts-list .van-swipe-cell .accounts-swipe-cell .accounts-list-right {
  width: 8rem;
  margin: 0 0;
  font-size: .37333rem;
  color: #2f3242;
  font-family: PingFang-SC-Medium;
  padding-top: .48rem
}

.accounts .new-accounts-list .van-swipe-cell .accounts-swipe-cell .accounts-list-right span {
  font-size: .32rem;
  color: #575c73
}

.accounts .new-accounts-list .van-swipe-cell .accounts-swipe-cell .accounts-list-right span .coinProtocol {
  margin-right: .13333rem;
  padding: .02667rem;
  padding-left: .08rem;
  padding-right: .08rem;
  background-color: #4f8dfe;
  color: #fff
}

.accounts .new-accounts-list .van-swipe-cell .van-swipe-cell__right {
  width: 2.13333rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.accounts .new-accounts-list .van-swipe-cell .van-swipe-cell__right .delete-button {
  width: 2.13333rem;
  background-color: #ff5745 !important;
  border: #ff5745 !important;
  padding: 0;
  margin: 0;
  text-align: center;
  font-family: PingFang-SC-Medium;
  font-size: .37333rem;
  font-weight: 400;
  color: #fff;
  height: 100%
}

.accounts .new-accounts-list .accounts-opendetails {
  background: #fff;
  text-align: center
}

.accounts .new-accounts-list .accounts-opendetails span {
  width: 3.2rem;
  height: 1.06667rem;
  line-height: 1.06667rem;
  display: inline-block;
  background: #f7f8fd;
  border-radius: .16rem;
  font-size: .37333rem;
  color: #3084ff
}

.mask:after {
  content: "";
  background: hsla(0, 0%, 100%, .5);
  position: absolute
}

.keyboard, .mask:after {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0
}

.keyboard {
  position: fixed;
  color: #1d2548;
  background: rgba(0, 0, 0, .5);
  z-index: 22;
  -webkit-transition: opacity 1.5s linear;
  transition: opacity 1.5s linear
}

.keyboard .password_box {
  top: 4.93333rem;
  width: 6.53333rem;
  height: 4.37333rem;
  padding: 0 .26667rem;
  background: #fff;
  border-radius: .4rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.keyboard .password_box, .keyboard .password_box:before {
  position: absolute;
  left: 50%;
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%)
}

.keyboard .password_box:before {
  content: "";
  top: 0;
  width: 3.2rem;
  height: .13333rem;
  background: #237bff
}

.keyboard .password_box > :first-child {
  font-size: .42667rem;
  font-family: PingFang SC;
  font-weight: 500
}

.keyboard .password_box > :last-child {
  font-size: .37333rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #2385ff
}

.keyboard .password_box > div {
  margin: .4rem 0;
  width: 6rem;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 0 .64rem
}

.keyboard .password_box > div, .keyboard .password_box > div > span {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex
}

.keyboard .password_box > div > span {
  width: .85333rem;
  height: .85333rem;
  background: #ebedf2;
  border-radius: .13333rem;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.keyboard .password_box > div > span span {
  display: block;
  width: .21333rem;
  height: .21333rem;
  background: #373c4a;
  border-radius: 50%
}

.board_box {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 5.46667rem;
  padding: .24rem 0;
  background: #f7f7f7;
  -webkit-transition: bottom .2s linear;
  transition: bottom .2s linear;
  z-index: 33
}

.board_box, .board_box .board_left {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex
}

.board_box .board_left {
  width: 7.54667rem;
  padding: 0 .24rem;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap
}

.board_box .board_left > span {
  width: 2.18667rem;
  height: 1.06667rem;
  font-size: .48rem;
  font-family: DIN;
  font-weight: 700;
  color: #373c4a;
  background: #fff;
  border-radius: .13333rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.board_box .board_left > span:active {
  background: #dfe3ed
}

.board_box .board_left > :nth-child(10) {
  width: 4.64rem
}

.board_box .board_right > :first-child {
  width: 2.18667rem;
  height: 1.06667rem;
  background: #fff;
  border-radius: .13333rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.board_box .board_right > :first-child img {
  width: .53333rem;
  height: .37333rem
}

.board_box .board_right > :first-child:active {
  background: #dfe3ed
}

.board_box .board_right > :last-child {
  width: 2.18667rem;
  height: 3.68rem;
  margin-top: .24rem;
  background: #2385ff;
  border-radius: .13333rem;
  font-size: .42667rem;
  font-family: PingFang SC;
  font-weight: 700;
  color: #fff;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.board_box .board_right > :last-child:active {
  opacity: .7
}

.fadeIn {
  display: block
}

.down {
  bottom: -50%
}


.venuesDetail .venues {
  display: flex;
  width: 100vw;
  box-sizing: border-box;
  margin: .32rem 0;
  padding: 0 .4rem;
  align-items: center;
  font-size: .32rem;
}

.venuesDetail .venues .left-nums {
  margin-left: .2rem;
  font-size: 0.32rem;
}

.venuesDetail .venues img {
  width: .90667rem;
  margin-left: .13333rem;
  height: .53333rem
}

.venuesDetail .venuesList .top {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 1.73333rem;
  background-color: #eef0f8;
  border-radius: .13333rem;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  margin-left: .4rem;
  margin-right: .4rem;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding-left: .42667rem;
  padding-right: .4rem
}

.venuesDetail .venuesList .top .left .left-top {
  margin-bottom: .08rem
}

.venuesDetail .venuesList .top .left .left-top img {
  width: .26667rem;
  height: .26667rem;
  margin-right: .08rem
}

.venuesDetail .venuesList .top .left .left-top .main-number {
  font-family: PingFang-SC-Medium;
  font-size: .29333rem;
  font-weight: 400
}

.venuesDetail .venuesList .top .left .money {
  font-family: DIN-Medium;
  font-size: .37333rem;
  font-weight: 700;
  margin-top: .10667rem
}

.venuesDetail .venuesList .top .onClickBack {
  width: 2.66667rem;
  height: .88rem;
  padding: 0;
  background-color: #3084ff;
  border-radius: .13333rem
}

.venuesDetail .venuesList .top .onClickBack .van-button__text {
  width: 1.86667rem;
  height: .8rem;
  text-align: center;
  color: #fff;
  line-height: .8rem;
  font-family: PingFang-SC-Medium;
  font-size: .34667rem;
  font-weight: 500
}

.venuesDetail .venuesList .listbox {
  padding-left: .32rem;
  padding-right: .32rem
}

.venuesDetail .venuesList .listbox .item {
  height: 1.49rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(255, 255, 255, 0.10);
  border: .03rem solid rgba(255, 255, 255, 0.10);
  border-radius: .2rem;
  margin-bottom: .27rem;
  padding: 0 .53rem;
}

.venuesDetail .venuesList .listbox .item .out {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.venuesDetail .venuesList .listbox .item .out .tittleText {
  font-size: 0.37rem;
  flex-shrink: 0;
  margin-right: .16rem;
}

.venuesDetail .venuesList .listbox .item .out img {
  width: .43rem;
}

.venuesDetail .venuesList .listbox .item .moneyText {
  font-family: Gilroy;
  font-size: .43rem;
}


</style>



// WEBPACK FOOTER //
// src/components/account.vue